import * as React from "react";
import { JSX } from "react/jsx-runtime";
const DragIcon = ({
  color = "#fff",
  ...props
}: JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M10 17V3m-7 7h14m-4 6-2.293 2.293a1 1 0 0 1-1.414 0L7 16m-3-3-2.293-2.293a1 1 0 0 1 0-1.414L4 7m9-3-2.293-2.293a1 1 0 0 0-1.414 0L7 4m9 9 2.293-2.293a1 1 0 0 0 0-1.414L16 7"
    />
  </svg>
);
export default DragIcon;
